module.exports = __webpack_public_path__ + "static/media/farms.b71562b2.svg";